import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { Breadcrumb2Container } from "./Breadcrumb2Container"

export function removerBreadcrumbOriginal() {
    if (document.getElementById("breadcrumb-container") != null) {
        document.getElementById("breadcrumb-container").style.display = "none"
        document.getElementById("breadcrumb-container").setAttribute("nao-mostrar","true")
    }

    if (document.getElementById("submit-breadcrumb-antigo") != null) {
        document.getElementById("submit-breadcrumb-antigo").style.display = "none"
    }
    
}

export function renderizarBreadCrumb2() {

    renderizarComponentReact(
        Breadcrumb2Container,
        "breadcrumb2-container",
        false
    )
}

export function removerBreadcrumb2() {
    if (document.getElementById("breadcrumb-container") != null) {
        document.getElementById("breadcrumb-container").style.display = "block"
        document.getElementById("breadcrumb-container").setAttribute("nao-mostrar","false")
    }

    if (document.getElementById("submit-breadcrumb-antigo") != null) {
        document.getElementById("submit-breadcrumb-antigo").style.display = "block"
    }
    
    

    
}